import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import { QuizResultFeedback } from "../shared/quiz-result-feedback.js";
import { SubmitButton } from "../shared/submit-button.js";
import "react";
import { useTranslation } from "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import { QuizMedia } from "../shared/quiz-media.js";
import { QuizSolveDescription } from "../shared/quiz-solve-description.js";
import { DifficultyBadge, DebugQuizId } from "../shared/debug-quiz-id.js";
import "../../../utils/quiz-parser.js";
import { usePairingQuiz } from "../hooks/use-pairing-quiz.js";
import Lottie from "../../../node_modules/.pnpm/lottie-react@2.4.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/lottie-react/build/index.es.js";
import lineAnimation from "../pairing/assets/line-effect.json.js";
import dotAnimation from "../pairing/assets/dot-effect.json.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
import X from "../../../node_modules/.pnpm/lucide-react@0.309.0_react@18.3.1/node_modules/lucide-react/dist/esm/icons/x.js";
const LINE_COLOR_DEFAULT = "#55C3FF";
function PairingStudent({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false,
  onAnswerChange,
  disableSound = false,
  difficultyLevel
}) {
  const { t } = useTranslation("quiz");
  const {
    displayPairings,
    selected,
    lines,
    previewLine,
    hoveredPos,
    setHoveredPos,
    hasAnyAnswer,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    pairs,
    containerRef,
    leftRefs,
    rightRefs,
    handleSelect,
    handleClearPairByLeft,
    handleClearPairByRight,
    handleSubmit,
    recalcLines,
    getLineColor
  } = usePairingQuiz({
    quizId,
    quiz,
    onSolve,
    solveResult,
    showReallyTrue,
    isViewSolved,
    initialAnswers: initialAnswersProp,
    onAnswerChange
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        className: "space-y-2",
        children: [
          /* @__PURE__ */ jsxs("div", { className: "inline-flex gap-2 items-center", children: [
            /* @__PURE__ */ jsx("div", { className: "inline-flex gap-2 items-center px-3 py-1 text-sm font-bold text-white bg-[#55C3FF] rounded-lg", children: /* @__PURE__ */ jsx("span", { children: t("types.pairing.label") }) }),
            /* @__PURE__ */ jsx(DifficultyBadge, { level: difficultyLevel }),
            /* @__PURE__ */ jsx(DebugQuizId, { quizId })
          ] }),
          /* @__PURE__ */ jsx("h3", { className: "text-2xl font-bold leading-relaxed text-gray-900", children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
          /* @__PURE__ */ jsx(QuizMedia, { image: quiz.image, imageMobile: quiz.imageMobile, desmos: quiz.desmos, vars: quiz.vars })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { ref: containerRef, className: "relative flex", children: [
      /* @__PURE__ */ jsx("div", { className: "flex flex-col shrink-0 z-10", children: pairs.left.map((item, index) => {
        var _a, _b;
        const pairing = displayPairings[index];
        const isPaired = pairing !== null;
        const isCurrent = (selected == null ? void 0 : selected.pos) === "left" && (selected == null ? void 0 : selected.index) === index;
        const isPending = selected !== null && selected.pos !== "left";
        const isHovered = (hoveredPos == null ? void 0 : hoveredPos.pos) === "left" && (hoveredPos == null ? void 0 : hoveredPos.index) === index;
        const pairCorrect = isSolved ? (_a = solveResult == null ? void 0 : solveResult.corrects) == null ? void 0 : _a[index] : void 0;
        const isTrue = isSolved && (shouldShowCorrectAnswers || pairCorrect === true);
        const isFalse = isSolved && !shouldShowCorrectAnswers && pairCorrect === false && isPaired;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("relative cursor-pointer flex items-center mb-4 z-10", {
              "pointer-events-none": isSolved || isViewSolved
            }),
            onMouseEnter: () => setHoveredPos({ pos: "left", index }),
            onMouseLeave: () => setHoveredPos(null),
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: (el) => {
                    leftRefs.current[index] = el;
                  },
                  className: cn(
                    "w-[208px] md:w-[296px] gap-2 min-h-[96px] border-2 border-gray-400 text-[20px] font-medium text-gray-900 rounded-3xl p-4 flex justify-center items-center",
                    "[box-shadow:0px_4px_0px_0px_rgba(0,0,0,0.10)]",
                    (isHovered || isPending) && !isCurrent && !isTrue && !isFalse && "border-[#55C3FF] text-[#55C3FF] [box-shadow:0px_4px_0px_0px_rgba(85,195,255,0.30)]",
                    isCurrent && "text-[#2E96CE] bg-[#EEF9FF] border-[#55C3FF] [box-shadow:unset]",
                    isTrue && "border-[#3BD0AE] bg-[#E2F8F3] text-[#17AF8C] [box-shadow:unset]",
                    isFalse && "border-[#FF675E] bg-[#FFF0EF] text-[#FF675E] [box-shadow:unset]"
                  ),
                  onClick: () => handleSelect("left", index),
                  children: [
                    ((_b = item.image) == null ? void 0 : _b.signedUrl) && /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: item.image.signedUrl,
                        alt: "pairing",
                        onLoad: recalcLines
                      }
                    ),
                    item.answer && /* @__PURE__ */ jsx("div", { className: "text-center", children: /* @__PURE__ */ jsx(KatexText, { text: item.answer }) })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: cn(
                    "group w-8 h-8 absolute -right-4 top-1/2 -translate-y-1/2 overflow-hidden bg-gray-100 text-gray-500 text-[16px] font-semibold border-2 border-gray-400 rounded-full flex items-center justify-center z-20 cursor-pointer",
                    (isHovered || isPending) && !isCurrent && !(isCurrent || isPaired) && !isTrue && !isFalse && "bg-[#DDF3FF] border-[#55C3FF] text-[#55C3FF]",
                    (isCurrent || isPaired) && !isTrue && !isFalse && "bg-[#55C3FF] border-transparent text-white",
                    isTrue && "border-transparent bg-[#3BD0AE] text-white",
                    isFalse && "border-transparent bg-[#FF675E] text-white"
                  ),
                  onClick: (e) => {
                    e.stopPropagation();
                    if (isPaired) {
                      handleClearPairByLeft(index);
                    } else {
                      handleSelect("left", index);
                    }
                  },
                  children: [
                    index + 1,
                    isPaired && !isSolved && /* @__PURE__ */ jsx(
                      X,
                      {
                        className: "hidden group-hover:block absolute w-6 h-6 text-white bg-[#55C3FF]",
                        strokeWidth: 3
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "absolute top-1/2 -translate-y-1/2 w-8 h-8 -right-12 hidden",
                    isCurrent && (!hoveredPos || hoveredPos.pos === "left") && !hasAnyAnswer && "block"
                  ),
                  children: /* @__PURE__ */ jsx(Lottie, { animationData: lineAnimation, loop: true, autoPlay: true, style: { width: "100%", height: "100%" } })
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "absolute top-1/2 -translate-y-1/2 w-10 h-10 -right-5 hidden",
                    isPending && !hasAnyAnswer && "block"
                  ),
                  children: /* @__PURE__ */ jsx(Lottie, { animationData: dotAnimation, loop: true, autoPlay: true, style: { width: "100%", height: "100%" } })
                }
              )
            ]
          },
          `left-${index}`
        );
      }) }),
      /* @__PURE__ */ jsx("div", { className: "relative grow w-full min-w-[40px]" }),
      /* @__PURE__ */ jsxs(
        "svg",
        {
          className: "absolute inset-0 pointer-events-none z-0",
          style: { width: "100%", height: "100%", overflow: "visible" },
          children: [
            lines.map((line, i) => /* @__PURE__ */ jsx(
              "line",
              {
                x1: line.x1,
                y1: line.y1,
                x2: line.x2,
                y2: line.y2,
                stroke: getLineColor(line.leftIdx),
                strokeWidth: 3,
                strokeLinecap: "round"
              },
              i
            )),
            previewLine && /* @__PURE__ */ jsx(
              "line",
              {
                x1: previewLine.x1,
                y1: previewLine.y1,
                x2: previewLine.x2,
                y2: previewLine.y2,
                stroke: LINE_COLOR_DEFAULT,
                strokeWidth: 3,
                strokeLinecap: "round",
                strokeDasharray: "6 6"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "flex flex-col shrink-0 z-10", children: pairs.right.map((item, index) => {
        var _a, _b, _c;
        const isCurrent = (selected == null ? void 0 : selected.pos) === "right" && (selected == null ? void 0 : selected.index) === index;
        const isPending = selected !== null && selected.pos !== "right";
        const isHovered = (hoveredPos == null ? void 0 : hoveredPos.pos) === "right" && (hoveredPos == null ? void 0 : hoveredPos.index) === index;
        const pairedLeftIdx = displayPairings.findIndex((p) => (p == null ? void 0 : p.rightIndex) === index);
        const isPairedByAnyLeft = pairedLeftIdx !== -1;
        let isTrue = false;
        let isFalse = false;
        let dotNum = "";
        if (shouldShowCorrectAnswers) {
          const correctIdx = ((_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a.findIndex((key) => key === item.key)) ?? -1;
          if (correctIdx !== -1) {
            isTrue = true;
            dotNum = correctIdx + 1;
          }
        } else if (isSolved && isPairedByAnyLeft) {
          const pairCorrect = (_b = solveResult == null ? void 0 : solveResult.corrects) == null ? void 0 : _b[pairedLeftIdx];
          isTrue = pairCorrect === true;
          isFalse = pairCorrect === false;
          dotNum = pairedLeftIdx + 1;
        } else if (!isSolved && isPairedByAnyLeft) {
          dotNum = pairedLeftIdx + 1;
        }
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn("relative cursor-pointer flex items-center flex-row-reverse mb-4 z-10", {
              "pointer-events-none": isSolved || isViewSolved
            }),
            onMouseEnter: () => setHoveredPos({ pos: "right", index }),
            onMouseLeave: () => setHoveredPos(null),
            children: [
              /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: (el) => {
                    rightRefs.current[index] = el;
                  },
                  className: cn(
                    "w-[208px] md:w-[296px] gap-2 min-h-[96px] border-2 border-gray-400 text-[20px] font-medium text-gray-900 rounded-3xl p-4 flex justify-center items-center",
                    "[box-shadow:0px_4px_0px_0px_rgba(0,0,0,0.10)]",
                    (isHovered || isPending) && !isCurrent && !isTrue && !isFalse && "border-[#55C3FF] text-[#55C3FF] [box-shadow:0px_4px_0px_0px_rgba(85,195,255,0.30)]",
                    isCurrent && "text-[#2E96CE] bg-[#EEF9FF] border-[#55C3FF] [box-shadow:unset]",
                    isTrue && "border-[#3BD0AE] bg-[#E2F8F3] text-[#17AF8C] [box-shadow:unset]",
                    isFalse && "border-[#FF675E] bg-[#FFF0EF] text-[#FF675E] [box-shadow:unset]"
                  ),
                  onClick: () => handleSelect("right", index),
                  children: [
                    ((_c = item.image) == null ? void 0 : _c.signedUrl) && /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: item.image.signedUrl,
                        alt: "pairing",
                        onLoad: recalcLines
                      }
                    ),
                    item.answer && /* @__PURE__ */ jsx("div", { className: "text-center", children: /* @__PURE__ */ jsx(KatexText, { text: item.answer }) })
                  ]
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  className: cn(
                    "group w-8 h-8 absolute -left-4 top-1/2 -translate-y-1/2 overflow-hidden bg-white text-gray-500 text-[16px] font-semibold border-2 border-gray-400 rounded-full flex items-center justify-center z-20 cursor-pointer",
                    isPending && !isCurrent && !(isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-[#DDF3FF] border-[#55C3FF] text-[#55C3FF]",
                    isHovered && !isCurrent && !(isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-white border-[#55C3FF] text-[#55C3FF]",
                    (isCurrent || isPairedByAnyLeft) && !isTrue && !isFalse && "bg-[#55C3FF] border-transparent text-white",
                    isTrue && "border-transparent bg-[#3BD0AE] text-white",
                    isFalse && "border-transparent bg-[#FF675E] text-white"
                  ),
                  onClick: (e) => {
                    e.stopPropagation();
                    if (isPairedByAnyLeft) {
                      handleClearPairByRight(index);
                    } else {
                      handleSelect("right", index);
                    }
                  },
                  children: [
                    dotNum,
                    isPairedByAnyLeft && !isSolved && /* @__PURE__ */ jsx(
                      X,
                      {
                        className: "hidden group-hover:block absolute w-6 h-6 text-white bg-[#55C3FF]",
                        strokeWidth: 3
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "absolute top-1/2 -translate-y-1/2 w-8 h-8 -left-12 hidden",
                    isCurrent && (!hoveredPos || hoveredPos.pos === "right") && !hasAnyAnswer && "block"
                  ),
                  children: /* @__PURE__ */ jsx(Lottie, { animationData: lineAnimation, loop: true, autoPlay: true, style: { width: "100%", height: "100%" }, className: "rotate-180" })
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: cn(
                    "absolute top-1/2 -translate-y-1/2 w-10 h-10 -left-5 hidden",
                    isPending && !hasAnyAnswer && "block"
                  ),
                  children: /* @__PURE__ */ jsx(Lottie, { animationData: dotAnimation, loop: true, autoPlay: true, style: { width: "100%", height: "100%" } })
                }
              )
            ]
          },
          `right-${index}`
        );
      }) })
    ] }),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel ?? (canSubmit ? t("common.checkAnswer") : t("types.pairing.matchPairs"))
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizResultFeedback,
      {
        isCorrect: (solveResult == null ? void 0 : solveResult.correct) ?? false,
        show: isSolved,
        disableSound
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizSolveDescription,
      {
        description: (solveResult == null ? void 0 : solveResult.description) ?? void 0,
        commentaryImages: quiz.commentaryImages,
        vars: quiz.vars,
        id: `${quizId}-desc`,
        actionVisible: !(solveResult == null ? void 0 : solveResult.correct),
        actionLabel: isShowingCorrectAnswers ? t("common.viewMyAnswer") : t("common.viewCorrectAnswer"),
        onActionClick: () => setIsShowingCorrectAnswers((v) => !v)
      }
    )
  ] });
}
export {
  PairingStudent
};
//# sourceMappingURL=pairing-student.js.map
